import _HighchartsReact, { HighchartsReactProps, HighchartsReactRefObject } from "highcharts-react-official";
import HighchartsGantt from "highcharts/highcharts-gantt";
import { VerticalBox } from "../box/VerticalBox";
import * as Highcharts from "highcharts";
import { useResizeObserver } from "src/utils/useResizeObserver.ts";
import { useRef } from "react";

// Vite 8 (Rolldown) changed CJS interop: modules with __esModule:true are no longer
// auto-unwrapped, so the default import is the module.exports object at runtime.
// Access .default to get the actual component, with a fallback for future fixes.
const HighchartsReact = (
	(_HighchartsReact as unknown as { default?: typeof _HighchartsReact }).default ??
	_HighchartsReact
);

export interface AavoGanttViewProps extends Pick<HighchartsReactProps, "immutable"> {
	options: Highcharts.Options;
}

export const AavoGanttView = ({ options, immutable = false }: AavoGanttViewProps) => {
	const containerRef = useRef<HTMLDivElement>(null);
	const chartRef = useRef<HighchartsReactRefObject>(null);

	const setChartHeight = () => {
		if (!chartRef.current || !containerRef.current) return;
		const containerHeight = containerRef.current.clientHeight;

		const scrollablePlotAreaCurrentMinHeight =
			chartRef.current.chart.options.chart?.scrollablePlotArea?.minHeight ?? 0;

		const scrollablePlotAreaMinHeight = Math.max(
			containerHeight + 10,
			scrollablePlotAreaCurrentMinHeight,
		);

		chartRef.current.chart.update(
			{
				chart: {
					height: containerHeight,
					scrollablePlotArea: {
						minHeight: scrollablePlotAreaMinHeight,
					},
				},
			},
			true,
			false,
			false,
		);
	};

	useResizeObserver(
		containerRef,
		() => {
			setChartHeight();
		},
		[chartRef.current],
	);

	return (
		<VerticalBox
			ref={containerRef}
			sx={{
				flex: 1,
				display: "flex",
				alignItems: "stretch",
				overflow: "hidden",
				position: "relative",
				"& > *": {
					flex: 1,
				},
			}}
		>
			<HighchartsReact
				ref={chartRef}
				highcharts={HighchartsGantt}
				constructorType={"ganttChart"}
				allowChartUpdate={true}
				immutable={immutable}
				options={options}
			/>
		</VerticalBox>
	);
};
